import { BASE_URL } from "../../../config";
import Iconify from "../ui/Iconify";
import Button from "../ui/Buttons/button";

const GoogleSignIn = ({
  onClose,
  btnClass = "",
  btnText = "Sign in with Google",
  iconClass = "",
  textClass = "",
  disabled = false,
  onBeforeStart,
}) => {

  const loginWithGoogle = () => {
    if (disabled) return;
    if (typeof onBeforeStart === "function" && onBeforeStart() === false) {
      return;
    }
    window.open(`${BASE_URL}/auth/google/start`, "_self");
  };

  return (
    <Button
      className={`w-full flex items-center justify-center p-3 bg-white dark:!bg-dark_bg_grey text-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 ${btnClass}`}
      onClick={loginWithGoogle}
      disabled={disabled}
      type="button"
    >
      <Iconify className={`w-6 h-6 mr-2 ${iconClass}`} icon="logos:google-icon" />
      <span className={`ml-2 ${textClass}`}>{btnText}</span>
    </Button>
  );
};

export default GoogleSignIn;
